import { BuildRentType } from './BuildRentType';

export const BuildLoanTypeOptions = [
    {
        id: BuildRentType.FixRent,
        display: 'Fix-to-Rent',
    },
    {
        id: BuildRentType.BuildRent,
        display: 'Build-Rent',
    },
];
